import React, { useState, useEffect } from 'react';
import { QUOTES } from '../data';
import { IconUser, IconShop, IconArrow, IconCheck } from './Icons';

export default function Profile({ user, onLogout, onNavigate }) {
  const [toast, setToast] = useState(null);
  const [couponDismissed, setCouponDismissed] = useState(false);

  const initials = user?.FirstName
    ? `${user.FirstName[0]}${user.LastName?.[0] || ''}`.toUpperCase()
    : user?.Email?.[0]?.toUpperCase() || 'BH';
  const name = user?.FirstName ? `${user.FirstName} ${user.LastName || ''}`.trim() : 'Member';
  const email = user?.Email || '';
  const todayQ = QUOTES[new Date().getDate() % QUOTES.length];

  useEffect(() => {
    const onboardedDate = localStorage.getItem('bhn_onboarded_date');
    if (onboardedDate) {
      const days = (Date.now() - new Date(onboardedDate).getTime()) / (1000 * 60 * 60 * 24);
      if (days > 30) setCouponDismissed(true);
    }
  }, []);

  function showToast(msg) { setToast(msg); setTimeout(() => setToast(null), 2500); }

  function copyCode() {
    navigator.clipboard.writeText('BEHERENOW20').then(() => showToast('Code copied!')).catch(() => showToast('BEHERENOW20'));
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100%' }}>
      {toast && <div className="toast">{toast}</div>}

      <div className="profile-top" style={{ position: 'relative' }}>
        <div className="avatar">{initials}</div>
        <div>
          <div style={{ fontSize: 16, fontWeight: 700, color: '#111', letterSpacing: '-.2px' }}>{name}</div>
          <div style={{ fontSize: 12, color: '#A09888', marginTop: 2 }}>{email}</div>
        </div>
        {onNavigate && (
          <button
            onClick={() => onNavigate('today')}
            style={{
              position: 'absolute', top: 14, right: 18,
              background: 'none', border: 'none', cursor: 'pointer',
              fontSize: 13, color: '#3A6A2A', fontWeight: 600,
              padding: '6px 10px',
            }}
          >
            Done
          </button>
        )}
      </div>

      <div className="screen-body" style={{ width: '100%' }}>

        {/* Welcome gift — auto hides after 30 days */}
        {!couponDismissed && (
          <>
            <div className="section-label">Welcome gift</div>
            <div className="coupon-card">
              <div className="coupon-label">20% off your first order at beherenow.biz</div>
              <div className="coupon-code">BEHERENOW20</div>
              <div className="coupon-sub">Use this code at checkout to shop our wellness collection.</div>
              <div style={{ display: 'flex', gap: 10, marginTop: 14, alignItems: 'center' }}>
                <button onClick={copyCode} style={{ padding: '7px 16px', background: '#111', border: 'none', borderRadius: 7, fontSize: 11, fontWeight: 600, color: 'white', cursor: 'pointer' }}>Copy code</button>
                <a href="https://beherenow.biz" target="_blank" rel="noopener noreferrer" style={{ fontSize: 12, color: '#777', fontWeight: 500, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 4 }}>
                  Shop now <IconArrow size={12} color="#A09888" />
                </a>
              </div>
            </div>
          </>
        )}

        {/* Quote */}
        <div className="quote-card" style={{ marginBottom: 24 }}>
          <div className="quote-text">{todayQ.text}</div>
          {todayQ.author && <div className="quote-author">— {todayQ.author}</div>}
        </div>

        {/* Account */}
        <div className="section-label">Account</div>
        <div className="menu-row" onClick={() => window.open('https://be-here-now.outseta.com/profile', '_blank')}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}><IconUser size={17} color="#333" /> Manage account</span>
          <IconArrow size={13} color="#C8C4BE" />
        </div>
        <div className="menu-row" onClick={() => window.open('https://beherenow.biz', '_blank')}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}><IconShop size={17} color="#333" /> Visit beherenow.biz</span>
          <IconArrow size={13} color="#C8C4BE" />
        </div>
        <div className="menu-row" onClick={() => window.open('mailto:info@beherenow.biz')}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}><IconCheck size={17} color="#333" /> Contact support</span>
          <IconArrow size={13} color="#C8C4BE" />
        </div>
        <div className="menu-row danger" onClick={onLogout}>
          <span>Sign out</span>
          <IconArrow size={13} color="#8B2020" />
        </div>

        <div style={{ textAlign: 'center', fontSize: 10, color: '#D8D4CE', marginTop: 20, letterSpacing: '.1em', textTransform: 'uppercase' }}>Be Here Now · v2.0</div>
      </div>
    </div>
  );
}
